<template>
  <div class="welcome">
    <v-dialog
      transition="dialog-bottom-transition"
      width="1200"
      v-model="dialog"
      scrollable
    >
      <v-card v-if="assignedImage != null" height="1200">
        <v-card-text>
          <v-toolbar color="white" elevation="0">
            <v-btn
              icon
              class="background ml-1"
              @click="previousImage()"
              v-if="imageIndex != 0"
            >
              <v-icon class="secondary--text">mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon class="background ml-1" disabled v-if="imageIndex == 0">
              <v-icon class="secondary--text">mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              class="background ml-1"
              @click="nextImage()"
              v-if="imageIndex + 1 != allGalleries.length"
            >
              <v-icon class="primary--text">mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              icon
              class="background ml-1"
              disabled
              v-if="imageIndex + 1 == allGalleries.length"
            >
              <v-icon class="primary--text">mdi-chevron-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon class="background mr-1" @click="dialog = false">
              <v-icon class="primary--text">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div>
            <!-- <v-img max-height="300" contain :src="allGalleries[imageIndex].thumbnail_link"/> -->
            <v-row>
              <viewMoreLayout
                :title="allGalleries[imageIndex].title"
                :description="allGalleries[imageIndex].description"
                :programme="allGalleries[imageIndex].collection.community.name"
                :imageSrc="allGalleries[imageIndex].thumbnail_link"
                :tags="getTagsString(allGalleries[imageIndex].tags)"
                :project="allGalleries[imageIndex].collection.name"
                :country="allGalleries[imageIndex].country.name"
                :abstract="allGalleries[imageIndex].recent_abstract"
                :iconSrc="
                  setIconPath(
                    allGalleries[imageIndex].submission_type
                      .submissiontypecategory.name
                  )
                "
				:uuid="allGalleries[imageIndex].bitstream_uuid"
				:type="allGalleries[imageIndex].file_type"
              />
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout column>
      <v-flex xs12>
        <!-- add a search bar -->
      </v-flex>
      <!-- <v-progress-linear v-if="imageLoader" height="2" indeterminate color="primary"></v-progress-linear> -->

      <v-flex xs12 class="white">
        <v-container class="">
          <v-layout column>
            <v-flex xs12>
              <v-tabs v-model="innerCurrentTab" align-tabs="center">
                <v-tab
                  class="text-none"
				  tab-value="all"
                  style="width: 150px"
                  ><h3>{{ $t("allMsg") }}</h3></v-tab
                >
                <v-tab
                  class="text-none"
				  tab-value="images"
                  style="width: 150px"
                  ><h3>{{ $t("imagesMsg") }}</h3></v-tab
                >
                <v-tab
                  class="text-none"
				  tab-value="videos"
                  style="width: 150px"
                  ><h3>{{ $t("videosMsg") }}</h3></v-tab
                >
                <v-tab
                  class="text-none"
				  tab-value="audios"
                  style="width: 150px"
                  ><h3>{{ $t("audiosMsg") }}</h3></v-tab
                >
              </v-tabs>
              <v-container fluid class="mt-6">
                <v-row>
                  <v-col
                    v-for="(i, index) in allGalleries"
                    :key="index"
                    cols="12"
                    md="4"
                    class="mb-10"
                  >
                    <v-hover v-slot="{ hover }">
                      <v-card
                        class="mx"
                        height="300px"
                        align="center"
                        width="350px"
                      >
                        <v-img
                          v-if="
                            i.thumbnail_link != null && i.thumbnail_link != ''
                          "
                          :src="i.thumbnail_link"
                          cover
                          style="width: inherit; height: inherit"
                        >
                        </v-img>
                        <v-icon v-else size="300" color="#DCDCDC">
                          {{
                            setIconPath(
                              i.submission_type.submissiontypecategory.name
                            )
                          }}
                        </v-icon>
                        <!-- Hover Effect -->
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal white--text"
                            style="
                              position: absolute;
                              top: 0;
                              left: 0;
                              width: 100%;
                              height: 100%;
                              align-items: center;
                              justify-content: center;
                            "
                            @click="expandImage(i, index)"
                          >
                            <v-icon large class="white--text"
                              >mdi-magnify-plus-outline</v-icon
                            >
                            {{ $t("clickToViewMsg") }}
                          </div>
                        </v-expand-transition>
                        <v-card-actions>
                          <b style="color: #666666">{{ i.title }}</b>
                        </v-card-actions>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-container>
            </v-flex>

            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <div v-if="allGalleries.length != 0" class="my-15"></div>
                  <div v-else class="mx-5">
                    <!-- <v-skeleton-loader v-bind="attrs"
											type="table-heading, table-heading, table-heading, table-heading"></v-skeleton-loader> -->
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from "vue";
import viewMoreLayout from "../../../views/viewMoreLayout.vue";

export default {
  components: {
    viewMoreLayout,
  },
  props: {
    itemObjects: {
      default: null,
    },
	currentTab: {
		type: String
	}
  },
  data() {
    return {
      images: "",
      allGalleries: "",
      path: process.env.VUE_APP_API_URL,
      dialog: false,
      color: "",
      message: "",
      snackbar: false,
      drawer: false,

      activeGallery: "launch",
      mediaGroup: "launch",
      assignedAlbum: "6",
      assignedImage: null,
      imageIndex: 0,
      arrayNumber: null,

      absolute: true,
      overlay: true,
      opacity: 0.3,

      originalArray: [],
      imageArray: [],
      tab: null,
    };
  },
  watch: {
    itemObjects: {
      deep: true,
      handler(newVal) {
        this.allGalleries = newVal;
        this.imageIndex = 0;
      },
    },
  },

  mounted() {},
  created() {
    window.scrollTo(0, 0);
    this.allGalleries = this.itemObjects;
  },
  attrs() {},
  methods: {
    ...mapActions([]),
    expandImage(image, index) {
      this.dialog = true;
      this.assignedImage = image.thumbnail_link;
      this.imageIndex = index;
    },
    previousImage() {
      this.imageIndex -= 1;
      this.assignedImage = this.allGalleries[this.imageIndex];
    },
    nextImage() {
      this.imageIndex += 1;
      this.assignedImage = this.allGalleries[this.imageIndex];
    },

    closeDialog() {
      this.imageIndex = 0;
      this.dialog = false;
      this.assignedImage = null;
    },
    getTagsString(tags) {
      return JSON.parse(tags);
    },

    setIconPath(type) {
      if (type == "Image") {
        return "mdi-image";
      } else if (type == "Audio") {
        return "mdi-cassette";
      } else if (type == "Video") {
        return "mdi-video";
      } else {
        return "mdi-image";
      }
    },
  },
  computed: {
    ...mapGetters(["darkState"]),
	innerCurrentTab:{
		get(){
			return this.currentTab
		},
		set(val){
			this.$emit('update:currentTab',val)
		}
	}
  },
};
</script>
